import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {IoSearchCircleOutline} from "react-icons/io5";
import {toast} from "react-toastify";

import API from "../../Services/API";
import {BiCubeAlt} from "react-icons/bi";
import {GiTwoCoins} from "react-icons/gi";
import {useNavigate} from "react-router-dom";


const currencyFormat = Intl.NumberFormat('en-US');

// @ToDo List Of Companies + Send Search Term

function SearchServices() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [services, setServices] = React.useState([]);
    const [term, setTerm] = React.useState('');

    const onSearch = (val) => {
        setTerm(val.target.value);

        if (val.target.value.length > 2) {
            setIsLoaded(false);
            const params = {
                list: 1,
                orderType: 'desc',
                count: 20,
                search: val.target.value
            }
            API.getServices(params)
                .then((response) => {
                    setServices(response.data);
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else {
            setServices([]);
        }

    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title='جستجوی خدمات' hasBack={true}/>
            <section className="container-fluid  mt-3 py-5 rtl px-0 mx-0 ">
                <div className="row search-city mx-2">
                    <div className="col-12  border-secondary border-opacity-25">
                        <IoSearchCircleOutline className='text-secondary text-big-3'/>

                        <input
                            autoFocus
                            type="text" placeholder='جستجو در همه خدمات'
                            className='text-secondary text-small-1 pe-3 w-75 border-0 bg-transparent '
                            value={term}
                            onChange={(val) => onSearch(val)}
                        />
                    </div>
                </div>

                {
                    isLoaded && services.map(service => {
                            const price = service.price * (1 - (service.discount_percent / 100))
                            return (
                                <div className="row mx-2 service-search-card  mx-2 pt-2 px-0 " key={service.id}>
                                    <div className="col-12 fw-bolder text-muted  ">
                                        <BiCubeAlt className='ms-2 '/>
                                        {service.title}
                                    </div>
                                    <div className="col-1  border-bottom pb-2">
                                        &nbsp;
                                    </div>
                                    <div className="col-11 price-container px-0 mt-2 border-bottom pb-2">

                                        {service.price ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    service.discount_percent &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(service.price)}
                                                        &nbsp;
                                                        ریال
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                ریال
                                                &nbsp;
                                                <span className='text-small-3 bg-light text-secondary px-2 rounded '>
                                                    به ازای هر
                                                    &nbsp;
                                                    {
                                                        service.counting_unit.title
                                                    }
                                                </span>
                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                توافقی
                                            </div>
                                        }

                                    </div>
                                    <div className="col-12 py-2 text-small-2 text-muted">
                                        شرکت های خدماتی ارائه دهنده:
                                    </div>
                                    <div className="col-1 pb-2">
                                        &nbsp;
                                    </div>
                                    <div className="col-11 pb-2">
                                        {
                                            service.companies.map (company => {
                                                return (
                                                    <span
                                                        onClick={() => {
                                                            navigate(`/company/${company.id}`);
                                                        }
                                                        }
                                                        className='text-center badge badge-pill badge-primary bg-success bg-opacity-75  text-small-3 mx-2'>
                                                        {company.title}
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            );
                        }
                    )
                }
            </section>
        </React.Fragment>
    );
}

export default SearchServices;